module.exports = {
    // basic
    'profile': 'perfil',
    'contact-and-message-delivery': 'contacto y entrega de mensajes',
    'sms-delivery-method': 'método de entrega de texto',
    'entries-per-page': 'entradas por página',
    'page-options': 'opciones de página',
    'drop-down-keep-open-on-select': 'mantenga la lista desplegable abierta al seleccionar varios valores',
    'entry-page-options': 'cargar / entrada editar',
    'send-test-email': 'enviar correo electrónico de prueba',
    'send-test-message': 'enviar mensaje de prueba',
    'config-download': 'descargas',
    'config-download-title': 'estructura de carpetas zip',
    'config-download-well': 'bien',
    'config-download-entry-type': 'tipo de entrada',
    'config-download-upload-date': 'fecha de carga',

    // raw
    'send-test-email-succeeded': 'Enviar correo electrónico de prueba con éxito.',
    'send-test-email-failed': 'No se pudo enviar el correo electrónico de prueba.',
    'send-test-message-succeeded': 'Enviar mensaje de prueba con éxito.',
    'send-test-message-failed': 'Enviar mensaje de prueba fallido.',

    // template
    'my-account-mobile-help': (words) => `La información de <b>${words[0]}</b> se utilizará para enviar notificaciones de texto a las que se suscriba. Si es la primera vez que usa su cuenta o si está cambiando su número de teléfono móvil, puede hacer clic en <b>${words[1]}</b> para ayudar a garantizar la entrega correcta del mensaje.`,
    'my-account-email-help': (words) => `Se utilizarán <b>${words[0]}</b> para las notificaciones por correo electrónico a las que se suscriba. Si es la primera vez que usa su cuenta, o si está cambiando su dirección de correo electrónico, puede hacer clic en <b>${words[1]}</b> para ayudar a garantizar la correcta entrega del mensaje.`,

};
